import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './AboutContactUs.css'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

// Your original contact data (unchanged)
const contactPoints = [
    { country: 'India', phone: DefaultData?.DEFAULTCOMPANYPHONENUMBER, email: DefaultData?.DEFAULTCOMPANYEMAIL, address: DefaultData?.DEFAULTCOMPANYADDRESS},
];

const AboutContactUs = () => {
    // NEW: State and effect to fetch landing data
    
 const landingData = useContext(LandingContext);
    const pageStyles = {
        '--theme-primary-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
        '--theme-secondary-color': landingData?.themeColor2 || DefaultData?.THEMECOLOR1
    };
    return (
        // UPDATED: Apply the dynamic styles to the main container
        <div className="main-content" style={pageStyles}>
            <div className="contact-hero-section">
                <Container className="text-center">
                    <h1 className="hero-title">Get In Touch</h1>
                    <p className="hero-subtitle">We are here to help you 24/7. Reach out to us for any inquiries.</p>
                </Container>
            </div>

            <div className="page-content">
                <Container>
                    <section>
                        <h2 className="section-title text-center">Our Offices</h2>
                        <Row className="g-4 justify-content-center">
                            {contactPoints.map(contact => (
                                <Col md={6} lg={5} key={contact.country}>
                                    <Card className="h-100 contact-card">
                                        <Card.Body>
                                            <Card.Title as="h4">{contact.country}</Card.Title>
                                            <hr />
                                            <div className="contact-info">
                                                <p><i className="ri-map-pin-line"></i> <strong>Address:</strong> {contact.address}</p>
                                                <p><i className="ri-phone-line"></i> <strong>Phone:</strong> {contact.phone}</p>
                                                <p><i className="ri-mail-line"></i> <strong>Email:</strong> <a href={`mailto:${contact.email}`}>{contact.email}</a></p>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </section>
                </Container>
            </div>
        </div>
    );
};
  
export default AboutContactUs;